import { IObjectMap } from 'interfaces/inspection.interface'

export const removeEmptyFields = (data: any) => {
  Object.keys(data).forEach((key) => {
    if (data[key] === '' || data[key] == null) {
      delete data[key]
    }
  })
}

export const extractNotEmptyFields = (data: any) => {
  const obj: IObjectMap = {}
  for (const key of Object.keys(data || {})) {
    if (data[key] && data[key] !== '') {
      obj[key] = data[key]
    }
  }
  return obj
}
